<template>
  <!-- eslint-disable max-len -->
  <info class="article">
    <h1>{{ $t("EMPIRE_STRIKES_BACK") }}</h1>
    <div
      v-html="
        $t('EMPIRE_STRIKES_BACK_DESC_1', {
          imageLink1: 'https://oldstatic.appdb.to/images/DSC01963.JPG',
          imageLink2: 'https://oldstatic.appdb.to/images/DSC01964.JPG',
          imageLink3: 'https://oldstatic.appdb.to/images/DSC01966.JPG',
          imageLink4: 'https://oldstatic.appdb.to/images/DSC01968.JPG',
          imageLink5: 'https://oldstatic.appdb.to/images/DSC01971.JPG',
        })
      "
    ></div>
    <div v-html="$t('EMPIRE_STRIKES_BACK_DESC_2')"></div>
    <div
      v-html="
        $t('EMPIRE_STRIKES_BACK_DESC_3', {
          githubLink: 'https://github.com/ZonD80?tab=repositories',
        })
      "
    ></div>
    <div v-html="$t('EMPIRE_STRIKES_BACK_DESC_4')"></div>

    <template slot="sidebar">
      <h2>{{ $t("EMPIRE_STRIKES_BACK").toUpperCase() }}</h2>
      <p>{{ $t("EMPIRE_STRIKES_BACK_READ_FULL_STORY") }}</p>
      <img
        src="https://oldstatic.appdb.to/images/empire-right.jpg"
        width="100%"
      />
    </template>
  </info>
</template>

<script>
import Info from '@/components/Info';

export default {
  components: { Info },
  computed: {
    title() {
      return this.$t('EMPIRE_STRIKES_BACK');
    },
  },
};
</script>

<style lang="scss" scoped>
.article::v-deep img {
  max-width: 100%;
}
</style>
